import { render, staticRenderFns } from "./document-word.vue?vue&type=template&id=45b2d749&scoped=true&"
import script from "./document-word.vue?vue&type=script&lang=js&"
export * from "./document-word.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2d749",
  null
  
)

export default component.exports